import { Fade, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { ProformaBrief } from '../../types/walletProforma'
import ProformaRow from './ProformaRow'
import ProformaRowSkeleton from './ProformaRow.skeleton'
import useStyles from './styles/ProformasTable.styles'

interface ProformaListProps {
  data: ProformaBrief[]
  loading: boolean
  reloadData: () => void
}

export const ProformasTable: React.FC<ProformaListProps> = ({
  data,
  loading,
  reloadData
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">
            {getTranslate('Invoice Number')}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate('Creation Date')}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Last Update')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Type')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Status')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            data-cy="reloadDataForProformas"
            onClick={() => {
              reloadData()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <ProformaRowSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
              />
            ))
        : data.map((singleProforma: ProformaBrief) => (
            <Fade in timeout={600} key={singleProforma.proformaID}>
              <div data-cy="tableRowAccomodationList">
                <ProformaRow data={singleProforma} />
              </div>
            </Fade>
          ))}
    </div>
  )
}
